import * as React from "react";
import {isNullOrUndefined} from "util";
import {IconVariant, IconVariants} from "./Icon";

interface IProps {
	/**
	 * Icon name.
	 */
	icon: string;
	/**
	 * Icon size in pixels.
	 */
	size?: number;
	/**
	 * Icon variant
	 */
	variant?: IconVariant;
	/**
	 * Variant if icon is disabled.
	 */
	disabledVariant?: IconVariant;
	/**
	 * On Click handler
	 */
	onClick?: (event: React.MouseEvent<SVGSVGElement>) => void;
	/**
	 * Indicates if icon is disabled.
	 */
	disabled?: boolean;
	/**
	 * Transform function.
	 */
	transform?: string;
	/**
	 * If true, view box size is calculated from icon size.
	 */
	viewBoxFromSize?: boolean;
	/**
	 * On mouse over
	 * @param event
	 */
	onMouseOver?: (event: React.MouseEvent<SVGSVGElement>) => void;
	/**
	 * On mouse out
	 * @param event
	 */
	onMouseOut?: (event: React.MouseEvent<SVGSVGElement>) => void;
}

export default class IconWrapper extends React.Component<IProps, {}> {

	public static defaultProps: Partial<IProps> = {
		size: 24,
		variant: "blue",
		viewBoxFromSize: false
	};

	constructor(props: IProps) {
		super(props);
		this.onClick = this.onClick.bind(this);
	}

	render() {

		const styleFromProps = this.getIconCursorStyle();
		const viewBox = this.props.viewBoxFromSize ? `0 0 ${this.props.size} ${this.props.size}` : "0 0 24 24";
		const variant = this.props.disabled && this.props.disabledVariant ? this.props.disabledVariant : this.props.variant;
		return (
			<svg width={this.props.size}
				 height={this.props.size}
				 viewBox={viewBox}
				 onClick={this.onClick}
				 transform={this.props.transform}
				 style={styleFromProps}
				 onMouseOver={this.props.onMouseOver}
				 onMouseOut={this.props.onMouseOut}>
				<path fill={IconVariants[variant]}
					  d={this.props.icon}
					  shapeRendering={"optimizeQuality"}/>
			</svg>
		);
	}

	/**
	 * Get icon cursor style based on props.
	 * @return {any}
	 */
	getIconCursorStyle() {
		if (!isNullOrUndefined(this.props.onClick) && !this.props.disabled) {
			return {cursor: "pointer"};
		}
		else if (this.props.disabled) {
			return {cursor: "not-allowed"};
		}
		else {
			return {};
		}
	}

	onClick(event: React.MouseEvent<SVGSVGElement>) {
		if (!this.props.onClick || this.props.disabled) {
			return;
		}
		this.props.onClick(event);
	}
}
